var $18781839f93b0314$exports = {};
$18781839f93b0314$exports = {
    "removeButtonLabel": `Verwijderen`,
    "removeDescription": `Druk op Verwijderen om de tag te verwijderen.`
};


export {$18781839f93b0314$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
